export default {
	menu: 'Sicherheitsproblem melden',
	title:
		'Formular für externen Meldungseingang bei Schwachstellen im HPM und Sicherheitsvorfällen im Zusammenhang mit dem HPM',
	introduction:
		'Sollten Ihnen sicherheitsrelevante Erkenntnisse zum HÄVG-Prüfmodul (HPM) bekannt geworden sein, bitten wir Sie – ob als Vertragssoftwarehersteller, HZV- oder FAV-Praxis, IT-Dienstleister einer Praxis oder als sonstige meldende Person – uns diese über dieses Formular mitzuteilen.\nFür die Untersuchung Ihrer Meldung ist es wichtig, dass Sie uns möglichst konkrete Informationen zu der festgestellten Schwachstelle oder dem Sicherheitsvorfall geben, bei dem das HPM mittelbar oder unmittelbar betroffen war.\nUnsere Experten prüfen Ihre Meldung kurzfristig und geben Ihnen zeitnah eine Rückmeldung.',
	fields: {
		contactName: 'Ansprechpartner/in (Vor- und Nachname)',
		email: 'E-Mail-Adresse (optional)',
		phone: 'Telefonnummer (optional)',
		otherContact: 'Sonstige Kontaktmöglichkeit (optional)',
		reportTypes: 'Art der Meldung',
		description:
			'Beschreiben Sie den Sachverhalt: Was genau ist passiert oder aufgefallen?',
		discoveredAt: 'Wann haben Sie den Sachverhalt festgestellt?',
		measuresTaken:
			'Welche Maßnahmen haben Sie ggf. bereits ergriffen? (optional)',
		affectedInstances:
			'Wie viele Betriebsstätten (Instanzen des HPM) sind bei Ihnen betroffen?',
		hpmVersion: 'Welche Version des HPM ist betroffen?',
		operatingEnvironment:
			'In welcher Art von Betriebsumgebung setzen Sie das HPM ein?',
		operatingEnvironmentHint:
			'z. B. lokal auf einem Praxis-PC/Laptop, auf einem physischen Praxisserver oder in einer virtualisierten Umgebung. Bitte geben Sie bei einer virtualisierten Umgebung die Virtualisierungslösung an.',
		additionalInformation:
			'Weitere Informationen, die aus Ihrer Sicht wichtig sind (optional)',
		attachments: 'Nachweise/Anhänge (optional)',
		attachmentsHint:
			'Erlaubte Formate: PDF, PNG, JPG, LOG. Maximale Dateigröße: 10 MB pro Datei.',
		chooseFiles: 'Dateien auswählen'
	},
	uploadErrors: {
		invalidType:
			'Die Datei „{{fileName}}“ hat ein nicht unterstütztes Format. Erlaubt sind PDF, PNG, JPG und LOG.',
		fileTooLarge:
			'Die Datei „{{fileName}}“ ist zu groß. Die maximale Dateigröße beträgt 10 MB.',
		maxFiles:
			'Die Datei „{{fileName}}“ kann nicht hinzugefügt werden. Es dürfen maximal 10 Dateien hochgeladen werden.'
	},
	reportTypes: {
		vulnerability: 'Schwachstelle im HPM',
		incident: 'Sicherheitsvorfall im Zusammenhang mit dem HPM'
	},
	validation: {
		required: 'Dieses Feld ist erforderlich.',
		phone: 'Bitte geben Sie nur eine gültige Telefonnummer ein.',
		maxLength: 'Bitte geben Sie höchstens {{count}} Zeichen ein.',
		reportType: 'Bitte wählen Sie mindestens eine Art der Meldung aus.',
		futureDate: 'Das Datum darf nicht in der Zukunft liegen.',
		positiveInteger: 'Bitte geben Sie eine positive Ganzzahl ein.'
	},
	submit: 'Meldung absenden',
	error:
		'Die Meldung konnte leider nicht übermittelt werden. Bitte versuchen Sie es später erneut.',
	success: {
		title: 'Vielen Dank für Ihre Meldung.',
		message:
			'Wir werden Ihre Meldung kurzfristig prüfen und uns zeitnah bei Ihnen melden.'
	}
}
